import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { usePageTitle } from "@/components/layout/hooks/usePageTitle";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { Role } from "@/types/user";
import { GeneralTab } from "@/components/pages/account/components/GeneralTab";
import { SecurityTab } from "@/components/pages/account/components/SecurityTab";

export const AccountPage: React.FC = () => {
  const { t } = useTranslation();
  usePageTitle();
  const { userProfile } = useAuthenticatedUser();
  const [activeTab, setActiveTab] = React.useState("general");

  const showSecurityTab =
    userProfile?.role === Role.FRONT_DESK ||
    userProfile?.role === Role.HOTEL_ADMIN ||
    userProfile?.role === Role.TENANT_ADMIN;

  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="max-w-4xl mx-auto w-full">
        <h1 className="text-2xl font-semibold mb-6">
          {t("account.pageTitle")}
        </h1>

        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList>
            <TabsTrigger value="general">
              {t("account.tabs.general")}
            </TabsTrigger>
            {showSecurityTab && (
              <TabsTrigger value="security">
                {t("account.tabs.security")}
              </TabsTrigger>
            )}
          </TabsList>

          <TabsContent value="general" className="mt-6">
            {activeTab === "general" ? <GeneralTab /> : null}
          </TabsContent>

          {showSecurityTab && (
            <TabsContent value="security" className="mt-6">
              {activeTab === "security" ? <SecurityTab /> : null}
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
};
